import type { Namespace } from '../../../types.js';

export const auth: Namespace = {
  'auth.login.title': 'Вход',
  'auth.login.submit': 'Войти',
  'auth.login.email': 'Email',
  'auth.login.password': 'Пароль',
  'auth.logout.label': 'Выйти',
};
